const getRarityFromPercentage = (id, p) => {
    // console.log("id", id, "rarity", p);
    let rarities = ['common', 'rare', 'epic', 'legendary', 'wrong', 'first', 'unknown']; 
    if (p >= .20) {
        return rarities[0];
    }
    if (p >= .10) {
        return rarities[1];
    }
    if (p >= 0.03) {
        return rarities[2];
    }
    if (p >= 0) {
        return rarities[3];
    }
    if (id === -1 && p === -1) {
        return rarities[4];
    }
    if (p === -100) {
        return rarities[5];
    }
    return rarities[6]

}

const getRarityEmoji = (id, p) => {
    if (p >= .20) {
        return '⚡';
    }
    if (p >= .10) {
        return '🔥';
    }
    if (p >= .03) {
        return '✨';
    }
    if (p >= 0) {
        return '💥';
    }
    if (id === -1 && p === -1) {
        return '☠️';
    }
    if (p === -100) {
        return '🎆';
    }
    return '💢';
}

const getRarityIcon = (id, p) => {
    // console.log(id, p);
    if (p >= .20) {
        return '🟩';
    }
    if (p >= .10) {
        return '🟦';
    }
    if (p >= .03) {
        return '🟪';
    }
    if (p >= 0) {
        return '🟧';
    }
    if (p === -2) {
        return '⬜';
    }
    if (p === -100) {
        return '🟥';
    }
    return '⬛';
}

const getParticleEffect = (p) => {
    if (p >= .20) {
        return 'no-particles';
    }
    if (p >= .10) {
        return 'no-particles';
    }
    if (p >= .03) {
        return 'light-particles';
    }
    if (p >= 0) {
        return 'big-particles';
    }
    if (p === -2) {
        return 'no-particles';
    }
    if (p === -100) {
        return 'big-particles';
    }
    return 'no-particles';
}


export { getRarityFromPercentage, getRarityEmoji, getRarityIcon, getParticleEffect };